import { defineMessages } from 'react-intl';

export default defineMessages({
  openInTab: {
    id: 'create.editor.openInTab',
    defaultMessage: 'Open in another tab',
  },
  applyLink: {
    id: 'create.editor.applyLink',
    defaultMessage: 'Apply link',
  },
  headerOne: {
    id: 'create.editor.headerOne',
    defaultMessage: 'Header 1',
  },
  headerTwo: {
    id: 'create.editor.headerTwo',
    defaultMessage: 'Header 2',
  },
  headerThree: {
    id: 'create.editor.headerThree',
    defaultMessage: 'Header 3',
  },
  codeBlock: {
    id: 'create.editor.codeBlock',
    defaultMessage: 'Code block',
  },
  enterLink: {
    id: 'create.editor.enterLink',
    defaultMessage: 'Enter your link',
  },
  selectFile: {
    id: 'create.editor.selectFile',
    defaultMessage: 'Select your file',
  },
  upload: {
    id: 'create.editor.upload',
    defaultMessage: 'Upload',
  },
  enterVideo: {
    id: 'create.editor.enterVideo',
    defaultMessage: 'Enter your video embed code',
  },
  pasteVideo: {
    id: 'create.editor.pasteVideo',
    defaultMessage: 'Paste the code here',
  },
  embedVideo: {
    id: 'create.editor.embedVideo',
    defaultMessage: 'Embed video',
  },
  videoError: {
    id: 'create.editor.videoError',
    defaultMessage: 'There is a problem with your embed code',
  },
  maxUploadFileSize: {
    id: 'create.editor.maxUploadFileSize',
    defaultMessage: 'Maximum upload file size: 2 MB',
  },
  imageError: {
    id: 'create.editor.imageError',
    defaultMessage: 'Your file exceeds the maximum file size of 2MB',
  },
});
